var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-form-part"},[_c('ServiceField',_vm._g({attrs:{"init-with-value":_vm.serviceId,"hidden":""}},_vm.$listeners)),_vm._v(" "),_c('MarketSegmentRadioField',_vm._g({attrs:{"choices":_vm.marketSegments}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }